import React, { useEffect, useState } from "react";
import { Container, Table, Spinner, Pagination } from "react-bootstrap";
import brandAPI from "../../../../services/brandapi";
import moment from "moment";

const ViewBrand = ({ brandId, onHide }) => {
    const [brand, setBrand] = useState(null);
    const [statusLog, setStatusLog] = useState({ rows: [], count: 0 });
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const pageSize = 10;

    const fetchBrandDetails = async () => {
        setLoading(true);
        try {
            const res = await brandAPI.getBrandById(brandId);
            setBrand(res.data.brand);
            setStatusLog({
                rows: res.data.statusLog.rows,
                count: res.data.statusLog.count,
            });
        } catch (err) {
            console.error("Failed to fetch brand view", err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPaginatedLogs = async (pageNumber) => {
        setLoading(true);
        try {
            const res = await brandAPI.getBrandStatusLogs({
                brandId,
                pageSize,
                page: pageNumber,
            });
            setStatusLog({
                rows: res.data.result,
                count: res.data.totalRecords,
            });
            setPage(pageNumber);
        } catch (err) {
            console.error("Failed to fetch status logs", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBrandDetails();
    }, [brandId]);

    const handlePageChange = (newPage) => {
        fetchPaginatedLogs(newPage);
    };

    const totalPages = Math.ceil(statusLog.count / pageSize);

    return (
        <Container>
            {loading ? (
                <div className="text-center py-5">
                    <Spinner animation="border" />
                </div>
            ) : (
                <>

                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h4 className="mb-4">Brand: {brand?.name}</h4>
                            <p><strong>Slug:</strong> {brand?.slug}</p>
                            <p><strong>Status:</strong> {brand?.status === 1 ? "Active" : "Inactive"}</p>
                            <p><strong>Created At:</strong> {moment(brand?.createdAt).format("YYYY-MM-DD HH:mm")}</p>
                            <p><strong>Updated At:</strong> {moment(brand?.updatedAt).format("YYYY-MM-DD HH:mm")}</p>
                        </div>
                        {brand?.image && (
                            <div>
                                <img
                                    src={`${process.env.REACT_APP_IMAGE_URL}/uploads/${brand.image}`}
                                    alt={`${brand?.name} logo`}
                                    width={150} // Adjust the size as needed
                                    style={{ maxHeight: '150px', objectFit: 'cover' }} // Optional: for maintaining aspect ratio and preventing stretching
                                />
                            </div>
                        )}
                    </div>
                    <h5 className="mt-5">Status Logs</h5>
                    <Table bordered hover size="sm">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Old</th>
                                <th>New</th>
                                <th>Reason</th>
                                <th>Updated By</th>
                                <th>Updated At</th>
                            </tr>
                        </thead>
                        <tbody>
                            {statusLog.rows.map((log, index) => (
                                <tr key={log.id}>
                                    <td>{(page - 1) * pageSize + index + 1}</td>
                                    <td>{log.old_status}</td>
                                    <td>{log.new_status}</td>
                                    <td>{log.reason}</td>
                                    <td>{log.updatedAdmin?.name || "-"}</td>
                                    <td>{moment(log.updated_at).format("YYYY-MM-DD HH:mm")}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>

                    {statusLog.count > pageSize && (
                        <Pagination>
                            <Pagination.Prev
                                onClick={() => handlePageChange(page - 1)}
                                disabled={page === 1}
                            />
                            {[...Array(totalPages)].map((_, i) => (
                                <Pagination.Item
                                    key={i}
                                    active={i + 1 === page}
                                    onClick={() => handlePageChange(i + 1)}
                                >
                                    {i + 1}
                                </Pagination.Item>
                            ))}
                            <Pagination.Next
                                onClick={() => handlePageChange(page + 1)}
                                disabled={page === totalPages}
                            />
                        </Pagination>
                    )}
                </>
            )}
        </Container>
    );
};

export default ViewBrand;
